<template>
    <notification-list
        :notifications="$store.state.notifications.slice().reverse()"
        full-text
    />
</template>

<script>
    import NotificationList from "@/components/NotificationList";
    export default {
        name: "AllNotifications",
        title() {
            return this.$t("zonesPage.notificationsTitle");
        },
        components: {NotificationList}
    }
</script>

<style scoped>

</style>